/* eslint-disable @typescript-eslint/naming-convention */
import { CURLY_BRACES } from "@super-ui/constants";
import { getCloudinaryUrl, isEmpty } from "@swiggy-private/js-utils";
import { CloudinaryOptions } from "@swiggy-private/js-utils/dist/cloudinary/types";

export const containsTags = (text: string, tagsToBeSearched: Record<string, string>): boolean => {
    return text.includes(tagsToBeSearched.OPEN) && text.includes(tagsToBeSearched.CLOSE);
};

export const extractKeyFromWord = (word: string, tagsToBeSearched: Record<string, string>): string => {
    return word.replace(tagsToBeSearched.OPEN, "").replace(tagsToBeSearched.CLOSE, "");
};

/**
 * Replaces attribute placeholders in the given text with their corresponding values.
 *
 * @param text - The text containing attribute placeholders.
 * @param attributeValues - An optional object containing attribute values.
 * @param tagsToBeReplaced - An optional object containing tags for opening and closing the replaced attributes with their values.
 * @param tagsToBeSearched - An optional object containing tags for opening and closing the replaced attributes.
 * @returns The text with attribute placeholders replaced by their values.
 */
export const replaceAttributes = (
    text: string,
    attributeValues?: Record<string, string>,
    tagsToBeReplaced?: Record<string, string>,
    tagsToBeSearched: Record<string, string> = CURLY_BRACES,
): string => {
    if (isEmpty(text)) {
        return "";
    }
    if (containsTags(text, tagsToBeSearched)) {
        return text
            .split(" ")
            .map((word: string) => {
                if (word.includes(tagsToBeSearched.OPEN) && word.includes(tagsToBeSearched.CLOSE)) {
                    const key = extractKeyFromWord(word, tagsToBeSearched);
                    const replacement = attributeValues?.[key];
                    return replacement
                        ? `${tagsToBeReplaced?.OPEN || ""}${replacement}${tagsToBeReplaced?.CLOSE || ""}`
                        : "";
                }
                return word;
            })
            .filter(Boolean)
            .join(" ");
    }
    return text;
};

export const getBackgroundImage = (url: string, options?: CloudinaryOptions) =>
    `url(${getCloudinaryUrl(url, options)})`;

export * from "./lottieHelpers";
